<template>
  <form
    method="post"
    @submit.prevent="submit"
  >

    <div class="mb-2">
      <v-text-input
        :auto-focus="true"
        v-model="formData.title"
        label="word.title"
        :errors="errors.title"
        :required="true"
      />
    </div>

    <div class="mb-2">
      <v-text-input
        v-model="formData.help_text"
        label="word.help_text"
        :errors="errors.help_text"
      />
    </div>

    <v-item-config-choice
      v-if="researchItem && isChoice(researchItem.render_type)"
      :form-data="formData"
      :render-type="researchItem.render_type"
    />
    <v-item-config-stars
      v-if="researchItem && researchItem.render_type === 'stars'"
      :form-data="formData"
    />

    <div class="mt-3 d-flex justify-content-end">
      <div class="mr-2">
        <v-button
          @click="$emit('cancel')"
          type="button"
          style-type="secondary"
          text="word.cancel"
        />
      </div>
      <v-button
        type="submit"
        text="word.update"
      />
    </div>

    <div
      class="d-flex justify-content-center"
      v-if="loading"
    >
      <v-loader/>
    </div>
  </form>
</template>

<script>
import Button from '@/common/components/Button.vue';
import ItemConfigChoice from '@/organisation/components/items/ItemConfigChoice.vue';
import ItemConfigStars from '@/organisation/components/items/ItemConfigStars.vue';
import Loader from '@/common/components/Loader.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { isChoice } from '@/common/services/items';
import { updateItem, fetchResearchItem } from '@/organisation/api';

export default {
  name: 'ItemUpdateContainer',
  components: {
    'v-button': Button,
    'v-item-config-stars': ItemConfigStars,
    'v-item-config-choice': ItemConfigChoice,
    'v-loader': Loader,
    'v-text-input': TextInput,
  },
  props: {
    researchItemId: {
      type: Number,
      required: true,
    },
    organisationSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isChoice,
      formData: {
        title: '',
        help_text: '',
        config: {
          // Choices (single/multi); DEPRECATED;
          options: [],
          direction: 'horizontal',
          allow_other: false,
          exclusive_response: '',
          random: false,
          min_options: null,
          max_options: null,

          // Stars
          min_text: '',
          max_text: '',
        },
        // Choices (single/multi);
        options: [],
      },
      researchItem: null,
      loading: false,
      errors: {
        title: [],
        help_text: [],
        config: [],
      },
    };
  },
  methods: {
    async submit() {
      const response = await updateItem(
        this.researchItem.item.id, this.organisationSlug, this.formData,
      );
      if (response.status === 200) {
        this.$emit('updated');
      } else {
        this.errors = response.data;
      }
    },
    async fetchResearchItem() {
      const response = await fetchResearchItem(this.researchItemId);
      this.researchItem = response.data;

      this.formData.options = this.researchItem.item.options;
      this.formData.title = this.researchItem.title;
      this.formData.help_text = this.researchItem.help_text;
      this.formData.config = this.researchItem.config || {};
      if (this.researchItem.config.exclusive_response) {
        this.exclusiveResponse = true;
        this.formData.config.exclusive_response = this.researchItem.config.exclusive_response;
      }
    },
  },
  created() {
    this.fetchResearchItem();
  },
};
</script>
